module.exports = __webpack_public_path__ + "img/icons_18.981419c1.png";